

















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitaisRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteHospitaisRemuneracaoStore'
import ModalSuporteVisualizarGrupo from '@/components/RemuneracaoMedica/suporte/components/ModalSuporteVisualizarGrupo.vue'
import ModalCadastroHospitais from '@/components/RemuneracaoMedica/suporte/components/ModalCadastroHospitais.vue'
import ModalMotivosInclusao from '@/components/RemuneracaoMedica/suporte/components/ModalMotivosInclusao.vue'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'

@Component({
  components: {
    ModalSuporteVisualizarGrupo,
    ModalCadastroHospitais,
    ModalMotivosInclusao
  },
})
export default class ViewFinanceiroCadastroGrupoHospital extends Vue {
  readyState: boolean = false
  loadHospitais: boolean = false
  loadEditHospital: string = ''
  hospitalSearch: string = ''
  visualizar: boolean = false
  showIntermediateModal = false
  editingItem: any = {}
  
  get getSuporteHospitaisRemuneracaoStore() {
    return getModule(SuporteHospitaisRemuneracaoStore, this.$store)
  }

  get getGrupoHospital() { return this.getSuporteHospitaisRemuneracaoStore.grupoHospital }
  get loadingEditHospital() { return this.loadEditHospital }
  set loadingEditHospital(value: string) { this.loadEditHospital = value }

  get loadingHospitais() { return this.loadHospitais }
  set loadingHospitais(value: boolean) { this.loadHospitais = value }

  get getHospitaisTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
      { text: 'Código', class: 'table-headers', align: 'left', value: 'codigo' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'createdOn' },
      { text: 'Criado por', class: 'table-headers', align: 'left', value: 'criatedByNome' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModalEditarGrupo() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.visualizarGrupo
  }

  get showModalMotivosInclusao() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.motivosInclusao
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  visualizarGrupo(item: any) {
    this.visualizar = true
    this.getSuporteHospitaisRemuneracaoStore.getGrupoHospitalById(item.id)
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'visualizarGrupo', value: true })
  }

  async showScreenCadastroHospitais(item: any) {
    this.loadingEditHospital = item.id
    this.visualizar = false
    await this.getSuporteHospitaisRemuneracaoStore.getGrupoRepasses()
    await this.getSuporteHospitaisRemuneracaoStore.getModoUploadItems()
    await this.getSuporteHospitaisRemuneracaoStore.getCargaRepasseArquivoModoAgrupamento()
    await this.getSuporteHospitaisRemuneracaoStore.getCargaRegraResponsavelRepasse()
    await this.getSuporteHospitaisRemuneracaoStore.getHospitaisPorGrupo(item.id)
    await this.getSuporteHospitaisRemuneracaoStore.getTipoEmpresasMedicas()
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'hospital', value: true })
    this.loadingEditHospital = ''
  }

  editarGrupo() {
    this.visualizar = false
    this.getSuporteHospitaisRemuneracaoStore.getGrupoHospitalById(this.editingItem.id)
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'visualizarGrupo', value: true })
  }

  addGrupo() {
    this.visualizar = false
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'visualizarGrupo', value: true })
  }

  async editarMotivosInclusão(){
    this.visualizar = false
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'motivosInclusao', value: true })
  }

  openModalIntermediate(item) {
    this.editingItem = item
    this.showIntermediateModal = true
  }

  get editOptions() {
    return [
      {
        title: 'Grupo hospital',
        action: this.editarGrupo
      },
      {
        title: 'Motivos de inclusão',
        action: this.editarMotivosInclusão
      },
    ]
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await this.getSuporteHospitaisRemuneracaoStore.getTiposDeCarga()
    await this.getSuporteHospitaisRemuneracaoStore.getCalculoModoDisparo()
    await this.getSuporteHospitaisRemuneracaoStore.getGrupoHospital()
    this.readyState = true
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  @Watch('showModalEditarGrupo')
  onShowModalEditarGrupo(val: boolean){
    if(!val)
      this.showIntermediateModal = false
  }

  @Watch('showModalMotivosInclusao')
  onShowModalMotivosInclusao(val: boolean){
    if(!val)
      this.showIntermediateModal = false
  }
}
